export default "__VITE_ASSET__2Uok2EUE__"